import { render, staticRenderFns } from "./poinvpaym.vue?vue&type=template&id=3a60be00&scoped=true"
import script from "./poinvpaym.vue?vue&type=script&lang=js"
export * from "./poinvpaym.vue?vue&type=script&lang=js"
import style0 from "./poinvpaym.vue?vue&type=style&index=0&id=3a60be00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a60be00",
  null
  
)

export default component.exports